import React, { useState, useEffect } from 'react';
import { NavbarContainer, NavbarWrapper, Logo, NavMenu, NavItem, NavLink, MobileMenuButton, MobileMenu } from './Navbar.styles';
import { navItems } from '../../utils/constants';
import useLocale from '../../hooks/useLocale';
import LanguageToggle from '../../components/LanguageToggle';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { t } = useLocale();

  
  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      setScrolled(offset > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleNavClick = (href) => {
    setIsOpen(false);
    
   
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const localizedNav = t('nav') || [];

  return (
    <NavbarContainer $scrolled={scrolled}>
      <NavbarWrapper className="container">
        <Logo $scrolled={scrolled} href="#hero" onClick={(e) => {
          e.preventDefault();
          handleNavClick('#hero');
        }}>
          {t('personal.name')}
        </Logo>

       
        <NavMenu>
          {navItems.map((item, index) => (
            <NavItem key={index}>
              <NavLink 
                $scrolled={scrolled}
                href={item.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(item.href);
                }}
              >
                {localizedNav[index] || item.name}
              </NavLink>
            </NavItem>
          ))}
        </NavMenu>

       
        <MobileMenuButton onClick={toggleMenu} aria-label="Toggle menu">
          <span></span>
          <span></span>
          <span></span>
        </MobileMenuButton>

        
        <MobileMenu $isOpen={isOpen}>
          {navItems.map((item, index) => (
            <NavItem key={index}>
              <NavLink 
                $scrolled={scrolled}
                href={item.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(item.href);
                }}
              >
                {localizedNav[index] || item.name}
              </NavLink>
            </NavItem>
          ))}
        </MobileMenu>

        {/* Language toggle placed in navbar */}
        <div style={{ marginLeft: 16 }}>
          <LanguageToggle scrolled={scrolled} />
        </div>
      </NavbarWrapper>
    </NavbarContainer>
  );
};

export default Navbar;